var exports = {
  "M0": "VoiceSceneEmoteBar.module__bar___azltYn",
  "Zg": "VoiceSceneEmoteBar.module__emoji___azltYn",
  "OS": "VoiceSceneEmoteBar.module__more___azltYn",
  "lK": "VoiceSceneEmoteBar.module__moreIcon___azltYn",
};

module.exports = exports;
